import React, { FC, memo, useEffect, useState } from "../../../lib/teact/teact";
import { DBManager } from "../db/dbManager";
import store from "../store";

import './contact.scss'
import ParserSettings from "./parserSettings";
type OwerProps = {
    tinhId: string;
    onDataChange: () => void;
}

const ContactsConfig: FC<OwerProps> = ({

    tinhId,
    onDataChange,

}) => {
  
    
    
    return (
        <div className="contact-config-main">
            <ParserSettings tinhIdProp={tinhId}
                isGlobalConfig={false}
                onDataChange={onDataChange}
                
            ></ParserSettings>
        </div>
    )
}
export default memo(ContactsConfig)